import { render, staticRenderFns } from "./LanguageChooser.vue?vue&type=template&id=2455a9ab&"
import script from "./LanguageChooser.vue?vue&type=script&lang=js&"
export * from "./LanguageChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports